package com.iregained.site.components.sections.patients.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

val FaqItemWrapperStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        Modifier.fillMaxWidth().borderBottom(1.px, LineStyle.Solid, palette.custom.divider)
            .transition(Transition.of("background-color", 300.ms))
    }
    hover {
        val palette = colorMode.toSitePalette()
        Modifier.backgroundColor(palette.custom.lightGray.toRgb().copyf(alpha = 0.3f))
    }
}

val FaqHeaderStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().padding(topBottom = 24.px, leftRight = 16.px).cursor(Cursor.Pointer)
            .transition(Transition.of(TransitionProperty.All, duration = 300.ms))
    }
}